

export const INSPECTION_ROUTES = [
    {
        path: "inspectionRecordOverview",
        name: "inspectionRecordOverview",
        component: () =>
            import(/* webpackChunkName: "inspections" */ "@/modules/inspections/layouts/InspectionRecordOverview")
    },
    {
        path: "inspectionNewLayout",
        name: "inspectionNewLayout",
        component: () =>
            import(/* webpackChunkName: "inspections" */ "@/modules/inspections/layouts/InspectionNewLayout")
    },
    {
        path: "inspectionFormDesigner",
        name: "inspectionFormDesigner",
        component: () =>
            import(/* webpackChunkName: "inspections" */ "@/modules/inspections/components/formDesigner/InpectionFormDesigner")
    },
    {
        path: "inspectionDetailsForm",
        name: "inspectionDetailsForm",
        component: () =>
            import(/* webpackChunkName: "inspections" */ "@/modules/inspections/components/forms/InspectionDetailsForm")
    },
    {
        path: "inspectionOverview",
        name: "inspectionOverview",
        component: () =>
            import(/* webpackChunkName: "inspections" */ "@/modules/inspections/components/overview/InspectionOverview")
    },
    {
        path: "inspectionFormOverview",
        name: "inspectionFormOverview",
        component: () =>
            import(/* webpackChunkName: "inspections" */ "@/modules/inspections/layouts/InspectionFormOverview"),
        children:[
            {
                path: "inspectionFormDashboard",
                name: "inspectionFormDashboard",
                component: () =>
                    import(/* webpackChunkName: "inspections" */ "@/modules/inspections/components/overview/layouts/InspectionFormDashboard")
            },
            {
                path: "inspectionRecords",
                name: "inspectionRecords",
                component: () =>
                    import(/* webpackChunkName: "inspections" */ "@/modules/inspections/components/overview/layouts/InspectionRecords")
            },
            {
                path: "inspectionPermissions",
                name: "inspectionPermissions",
                component: () =>
                    import(/* webpackChunkName: "inspections" */ "@/modules/inspections/components/overview/layouts/InspectionPermissions")
            },
            {
                path: "inspectionSettings",
                name: "inspectionSettings",
                component: () =>
                    import(/* webpackChunkName: "inspections" */ "@/modules/inspections/components/overview/layouts/inpsectionSettings")
            },
        ]
    },

];
